var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReturningCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_734",
    "data-name": "Group 734",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_379",
    "data-name": "Rectangle 379",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12793",
    "data-name": "Path 12793",
    d: "M30,15A15,15,0,1,1,15,0,15,15,0,0,1,30,15",
    fill: "#7c97c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12794",
    "data-name": "Path 12794",
    d: "M24.646,16.065a.772.772,0,0,0-.9.613A8.9,8.9,0,0,1,8.115,20.645l2.143-.117A18.642,18.642,0,0,1,5.5,16.822a18.612,18.612,0,0,1-.639,6L6.6,21.2a10.446,10.446,0,0,0,18.661-4.238.771.771,0,0,0-.613-.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12795",
    "data-name": "Path 12795",
    d: "M5.354,13.936a.8.8,0,0,0,.145.014.773.773,0,0,0,.757-.627A8.9,8.9,0,0,1,21.885,9.356l-2.143.117a18.625,18.625,0,0,1,4.76,3.706,18.668,18.668,0,0,1,.639-6L23.4,8.8A10.446,10.446,0,0,0,4.741,13.034a.771.771,0,0,0,.613.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12796",
    "data-name": "Path 12796",
    d: "M15,21.979a.73.73,0,0,1-.73-.729v-1.1l-.166-.033a3.311,3.311,0,0,1-2.672-2.264.716.716,0,0,1,.114-.632.739.739,0,0,1,.591-.3.73.73,0,0,1,.694.5,2.071,2.071,0,0,0,1.58,1.314l.035.007.048.009.078.012.087.014h.006c.029,0,.058.007.089.009l.074.008h.007c.046,0,.086,0,.124,0l.031,0h.032c.055,0,.111,0,.168-.006l.074-.006c.04,0,.077-.007.115-.012l.083-.009.154-.027a1.655,1.655,0,0,0,1.519-1.516c.012-1.107-.985-1.439-2.1-1.708-.081-.021-.166-.04-.25-.061l-.1-.022c-1.447-.341-3.086-.724-3.086-2.834A2.7,2.7,0,0,1,14.1,9.865l.171-.031V8.752a.73.73,0,1,1,1.461,0v1.1l.164.034A2.889,2.889,0,0,1,18.22,11.8a.733.733,0,0,1-.7.954.753.753,0,0,1-.7-.5,1.621,1.621,0,0,0-1.2-.986c-.035-.009-.069-.016-.1-.023l-.032-.005c-.056-.013-.094-.017-.132-.023l-.046-.005c-.04-.005-.07-.007-.1-.009l-.054-.005c-.045,0-.081-.005-.118-.005h-.052c-.065,0-.125,0-.183.006l-.055.005-.123.01-.06.007c-.034,0-.069.011-.1.016l-.06.009c-1.195.235-1.332,1.012-1.335,1.335-.011,1.022.9,1.234,2.054,1.505l.195.048c1.074.25,3.3.771,3.291,3.082a2.731,2.731,0,0,1-.74,1.866A3.573,3.573,0,0,1,15.9,20.121l-.165.032v1.1a.731.731,0,0,1-.731.729",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReturningCustomer);
export default __webpack_public_path__ + "static/media/icon-returning_customer.f27719743736a4ac9138c558e6a32c3e.svg";
export { ForwardRef as ReactComponent };